<div [animate.enter]="'slide-in-top'"
     [animate.leave]="'slide-out-top'"
     class=" grid grid-cols-4 mt-3 mb-3  gap-3 rounded-2xl">
  <ng-content></ng-content>
</div>
